import React from 'react';
import { useEffect, useState } from 'react';
import './App.css';

import navLogo from './assets/AESA.svg';

import GetPDFButton from './components/GetPDFButton';

const API_URL = "https://apiatosoutorga.aesa.pb.gov.br"

function App() {

  const finalidadeOptions = [
    "ABASTECIMENTO_PUBLICO",
    "ABASTECIMENTO_RURAL",
    "AGROINDUSTRIAL",
    "AQUICULTURA",
    "COMERCIAL",
    "INDUSTRIAL",
    "IRRIGACAO",
    "LANCAMENTO_AGUAS_PLUVIAIS",
    "LANÇAMENTO_DE_EFLUENTES",
    "LAZER",
    "MINERACAO"
  ];

  const municipioFonteHidricaOptions = [
    "AGUIAR",
    "ÁGUA BRANCA",
    "ALAGOA GRANDE",
    "ALAGOA NOVA",
    "ALAGOINHA",
    "ALHANDRA",
    "ALGODÃO DE JANDAÍRA",
    "AMPARO",
    "APARECIDA",
    "ARAÇAGI",
    "ARARA",
    "ARARUNA",
    "AROEIRAS",
    "AREIA",
    "AREIA DE BARAÚNAS",
    "ASSUNÇÃO",
    "BARAÚNA",
    "BARRA DE SANTA ROSA",
    "BARRA DE SANTANA",
    "BARRA DE SÃO MIGUEL",
    "BAYEUX",
    "BELÉM",
    "BELÉM DO BREJO DO CRUZ",
    "BERNARDINO BATISTA",
    "BOA VENTURA",
    "BOA VISTA",
    "BOQUEIRÃO",
    "BOM JESUS",
    "BOM SUCESSO",
    "BONITO DE SANTA FÉ",
    "BORBOREMA",
    "BREJO DO CRUZ",
    "BREJO DOS SANTOS",
    "CAAPORÃ",
    "CABACEIRAS",
    "CABEDELO",
    "CACHOEIRA DOS ÍNDIOS",
    "CAIÇARA",
    "CAJAZEIRAS",
    "CAJAZEIRINHAS",
    "CALDAS BRANDÃO",
    "CAMALAÚ",
    "CAMPINA GRANDE",
    "CAPIM",
    "CARAÚBAS",
    "CASSERENGUE",
    "CATINGUEIRA",
    "CATOLÉ DO ROCHA",
    "CATURITÉ",
    "CONCEIÇÃO",
    "CONDE",
    "CONDADO",
    "CONGO",
    "COREMAS",
    "COXIXOLA",
    "CRUZ DO ESPÍRITO SANTO",
    "CUBATI",
    "CUITÉ",
    "CUITEGI",
    "CUITÉ DE MAMANGUAPE",
    "CURRAL DE CIMA",
    "CURRAL VELHO",
    "DAMIÃO",
    "DESTERRO",
    "DIAMANTE",
    "DONA INÊS",
    "EMAS",
    "ESPERANÇA",
    "FAGUNDES",
    "FREI MARTINHO",
    "GADO BRAVO",
    "GUARABIRA",
    "GURINHÉM",
    "GURJÃO",
    "IBIARA",
    "IGARACY",
    "IMACULADA",
    "INGÁ",
    "ITABAIANA",
    "ITAMBÉ",
    "ITAPORANGA",
    "ITAPOROROCA",
    "ITATUBA",
    "JACARAÚ",
    "JERICÓ",
    "JOÃO PESSOA",
    "JOCA CLAUDINO",
    "JOÃO PESSOA",
    "JUAREZ TÁVORA",
    "JUAZEIRINHO",
    "JUNCO DO SERIDÓ",
    "JURIPIRANGA",
    "JURU",
    "LAGOA",
    "LAGOA DE DENTRO",
    "LAGOA SECA",
    "LASTRO",
    "LIVRAMENTO",
    "LUCENA",
    "MALTA",
    "MAMANGUAPE",
    "MANAÍRA",
    "MARCAÇÃO",
    "MARI",
    "MARIZÓPOLIS",
    "MASSARANDUBA",
    "MATO GROSSO",
    "MATARACA",
    "MATURÉIA",
    "MÃE D'ÁGUA",
    "MOGEIRO",
    "MONTE HOREBE",
    "MONTEIRO",
    "MULUNGU",
    "NATUBA",
    "NAZAREZINHO",
    "NOVA FLORESTA",
    "NOVA OLINDA",
    "NOVA PALMEIRA",
    "OLHO D'ÁGUA",
    "OLIVEDOS",
    "OURO VELHO",
    "PARARI",
    "PASSAGEM",
    "PATOS",
    "PAULISTA",
    "PEDRA BRANCA",
    "PEDRA LAVRADA",
    "PEDRAS DE FOGO",
    "PIANCÓ",
    "PICUÍ",
    "PILAR",
    "PILÕES",
    "PILÕEZINHOS",
    "PIRPIRITUBA",
    "PITIMBU",
    "POCINHOS",
    "POMBAL",
    "POÇO DANTAS",
    "POÇO DE JOSÉ DE MOURA",
    "PRATA",
    "PRINCESA ISABEL",
    "QUEIMADAS",
    "QUIXABA",
    "REMÍGIO",
    "RIACHÃO",
    "RIACHÃO DO BACAMARTE",
    "RIACHÃO DO POÇO",
    "RIACHO DOS CAVALOS",
    "RIO TINTO",
    "SALGADINHO",
    "SALGADO DE SÃO FÉLIX",
    "SANTA CECÍLIA",
    "SANTA CRUZ",
    "SANTA HELENA",
    "SANTA INÊS",
    "SANTA LUZIA",
    "SANTA RITA",
    "SANTA TERESINHA",
    "SANTANA DE MANGUEIRA",
    "SANTANA DOS GARROTES",
    "SANTO ANDRÉ",
    "SAPÉ",
    "SÃO BENTINHO",
    "SÃO BENTO",
    "SÃO DOMINGOS",
    "SÃO DOMINGOS DO CARIRI",
    "SÃO FRANCISCO",
    "SÃO JOÃO DO CARIRI",
    "SÃO JOÃO DO RIO DO PEIXE",
    "SÃO JOÃO DO TIGRE",
    "SÃO JOSÉ DA LAGOA TAPADA",
    "SÃO JOSÉ DE CAIANA",
    "SÃO JOSÉ DE ESPINHARAS",
    "SÃO JOSÉ DE PIRANHAS",
    "SÃO JOSÉ DE PRINCESA",
    "SÃO JOSÉ DO BONFIM",
    "SÃO JOSÉ DO BREJO DO CRUZ",
    "SÃO JOSÉ DO SABUGI",
    "SÃO JOSÉ DOS CORDEIROS",
    "SÃO JOSÉ DOS RAMOS",
    "SÃO MAMEDE",
    "SÃO MIGUEL DE TAIPU",
    "SÃO SEBASTIÃO DE LAGOA DE ROÇA",
    "SÃO SEBASTIÃO DO UMBUZEIRO",
    "SÃO VICENTE DO SERIDÓ",
    "SERRA BRANCA",
    "SERRA DA RAIZ",
    "SERRA GRANDE",
    "SERRA REDONDA",
    "SERRARIA",
    "SERTÃOZINHO",
    "SOBRADO",
    "SOLEDADE",
    "SOLÂNEA",
    "SOSSÊGO",
    "SOUSA",
    "SUMÉ",
    "TACIMA",
    "TAPEROÁ",
    "TAVARES",
    "TEIXEIRA",
    "TENÓRIO",
    "TRIUNFO",
    "UIRAÚNA",
    "VÁRZEA",
    "VIEIRÓPOLIS",
    "VISTA SERRANA"
  ];

  const baciaHidrograficaOptions = [
    "Abiaí",
    "Alto Curso do Rio Paraíba",
    "Alto Curso do Rio Piranhas",
    "Baixo Curso do Rio Paraíba",
    "Camaratuba",
    "Curimataú",
    "Espinharas",
    "Gramame",
    "Guaju",
    "Jacu",
    "Mamanguape",
    "Médio Curso do Rio Paraíba",
    "Médio Curso do Rio Piranhas",
    "Miriri",
    "Peixe",
    "Piancó",
    "Seridó Ocidental Paraibano",
    "Taperoá",
    "Trairi"
  ];

  const [fullList, setFullList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);

  const [inputFilter, setInputFilter] = useState({
    numeroOutorga: ``,
    numeroProcesso: ``,
    municipioFonteHidrica: `todos`,
    baciaHidrografica: `todos`,
    finalidade: `todos`,
    novaOutorga: true,
    renovacaoOutorga: true,
    outorgasVencidas: true,
    outorgasNaoVencidas: true,
    dataValidadeInicial: ``,
    dataValidadeFinal: ``,
    dataEmissaoInicial: ``,
    dataEmissaoFinal: ``
  });

  const { numeroOutorga, numeroProcesso, municipioFonteHidrica, baciaHidrografica, finalidade, novaOutorga, renovacaoOutorga, dataValidadeInicial, dataValidadeFinal, dataEmissaoInicial, dataEmissaoFinal, outorgasVencidas, outorgasNaoVencidas } = inputFilter;

  const elementsPerPage = 20;

  const isVencida = (e) => {
    const currentDate = new Date();
    const elementDate = new Date(e);
    return currentDate > elementDate;
  };

  const generatePages = async (responseInput) => {
    let filtered = [];
    let temp = [];
    for await (let element of responseInput) {
      if (temp.length === elementsPerPage) {
        filtered.push(temp);
        temp = [];
      }
      temp.push(element);
    }
    if (temp.length) {
      filtered.push(temp);
    }
    setFilteredList(filtered);
  };

  const handleCurrentPage = (num) => {
    setPage(page + num);
  };

  const handleFilterInput = (element, checkbox = false) => {
    if (checkbox) {
      setInputFilter({ ...inputFilter, [element.target.name]: element.target.checked });
    } else {
      setInputFilter({ ...inputFilter, [element.target.name]: element.target.value });
    }
  };

  const handleSearch = async () => {
    let flatFiltered = [];
    fullList.forEach(element => flatFiltered.push(element));

    if (inputFilter.numeroOutorga.trim().length > 0) {
      flatFiltered = flatFiltered.filter(element => element.numeroOutorga === inputFilter.numeroOutorga.trim());
    }
    if (inputFilter.numeroProcesso.trim().length > 0) {
      flatFiltered = flatFiltered.filter(element => element.numeroProcesso === inputFilter.numeroProcesso.trim());
    }
    if (inputFilter.municipioFonteHidrica !== "todos") {
      flatFiltered = flatFiltered.filter(element => element.municipioFonteHidrica === inputFilter.municipioFonteHidrica.trim());
    }
    if (inputFilter.baciaHidrografica !== "todos") {
      flatFiltered = flatFiltered.filter(element => element.baciaHidrografica === inputFilter.baciaHidrografica.trim());
    }
    if (inputFilter.finalidade !== "todos") {
      flatFiltered = flatFiltered.filter(element => element.finalidade === inputFilter.finalidade.trim());
    }
    if (inputFilter.novaOutorga && !inputFilter.renovacaoOutorga) {
      flatFiltered = flatFiltered.filter(element => element.novaOutorga);
    }
    if (!inputFilter.novaOutorga && inputFilter.renovacaoOutorga) {
      flatFiltered = flatFiltered.filter(element => !element.novaOutorga);
    }
    if (inputFilter.outorgasVencidas && !inputFilter.outorgasNaoVencidas) {
      flatFiltered = flatFiltered.filter(element => {
        const currentDate = new Date();
        const elementDate = new Date(element.dataValidadeOutorga);
        return currentDate > elementDate;
      });
    }
    if (!inputFilter.outorgasVencidas && inputFilter.outorgasNaoVencidas) {
      flatFiltered = flatFiltered.filter(element => {
        const currentDate = new Date();
        const elementDate = new Date(element.dataValidadeOutorga);
        return currentDate <= elementDate;
      });
    }

    let filterDate;

    filterDate = new Date(inputFilter.dataEmissaoInicial);
    filterDate.setHours(0, 0, 0);
    filterDate.setDate(filterDate.getDate() + 1);
    if (!isNaN(filterDate)) {
      flatFiltered = flatFiltered.filter(element => {
        let elementDate = new Date(element.dataEmissaoOutorga);
        elementDate.setHours(0, 0, 0);
        return filterDate <= elementDate;
      }
      );
    }
    filterDate = new Date(inputFilter.dataEmissaoFinal);
    filterDate.setHours(0, 0, 0);
    filterDate.setDate(filterDate.getDate() + 1);
    if (!isNaN(filterDate)) {
      flatFiltered = flatFiltered.filter(element => {
        let elementDate = new Date(element.dataEmissaoOutorga);
        elementDate.setHours(0, 0, 0);
        return filterDate >= elementDate;
      }
      );
    }

    filterDate = new Date(inputFilter.dataValidadeInicial);
    filterDate.setHours(0, 0, 0);
    filterDate.setDate(filterDate.getDate() + 1);
    if (!isNaN(filterDate)) {
      flatFiltered = flatFiltered.filter(element => {
        let elementDate = new Date(element.dataValidadeOutorga);
        elementDate.setHours(0, 0, 0);
        return filterDate <= elementDate;
      }
      );
    }
    filterDate = new Date(inputFilter.dataValidadeFinal);
    filterDate.setHours(0, 0, 0);
    filterDate.setDate(filterDate.getDate() + 1);
    if (!isNaN(filterDate)) {
      flatFiltered = flatFiltered.filter(element => {
        let elementDate = new Date(element.dataValidadeOutorga);
        elementDate.setHours(0, 0, 0);
        return filterDate >= elementDate;
      }
      );
    }

    setPage(0);
    generatePages(flatFiltered);
  };

  const filteredListLength = () => {
    let listLength = 0;
    filteredList.forEach(page => page.forEach(element => listLength++));

    return listLength;
  };

  const handleClean = () => {
    setPage(0);
    setInputFilter({
      numeroOutorga: ``,
      numeroProcesso: ``,
      municipioFonteHidrica: `todos`,
      baciaHidrografica: `todos`,
      finalidade: `todos`,
      novaOutorga: true,
      renovacaoOutorga: true,
      outorgasVencidas: true,
      outorgasNaoVencidas: true,
      dataValidadeInicial: ``,
      dataValidadeFinal: ``,
      dataEmissaoInicial: ``,
      dataEmissaoFinal: ``
    });
  };

  const handleInit = async () => {
    const response1 = await fetch(`${API_URL}/initPT1`);
    const jsonResponse1 = await response1.json();
    await generatePages(await jsonResponse1);
    setIsLoading(false);
    const response2 = await fetch(`${API_URL}/initPT2`);
    const jsonResponse2 = await response2.json();
    setFullList(await jsonResponse2);
    await generatePages(await jsonResponse2);
    setIsInitialized(true);
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <nav className="navbar">
        <a href="https://www.aesa.pb.gov.br" target="blank">
          <img src={navLogo} alt="AESA" height="40" />
        </a>
      </nav>
      <div className="home">
        <h1>Atos de Outorgas</h1>
        <div className="box">
          <h2>Filtros</h2>
          <div className="divider" />
          <div className="input-group-row">
            <div className="input-container">
              <label htmlFor="numeroOutorga" className="form-label">Nº da outorga</label>
              <input type="text" id="numeroOutorga" placeholder="123/456" name="numeroOutorga" value={numeroOutorga} onChange={e => handleFilterInput(e)} />
            </div>
            <div className="input-container">
              <label htmlFor="numeroProcesso" className="form-label">Nº do processo</label>
              <input type="text" id="numeroProcesso" placeholder="123/456" name="numeroProcesso" value={numeroProcesso} onChange={e => handleFilterInput(e)} />
            </div>
          </div>
          <div className="input-group-row">
            <div className="input-container">
              <label htmlFor="municipioFonteHidrica">Município fonte hídrica</label>
              <select className="form-select" id="municipioFonteHidrica" name="municipioFonteHidrica" value={municipioFonteHidrica} onChange={e => handleFilterInput(e)}>
                <option value="todos">Todos</option>
                {municipioFonteHidricaOptions.map((e) => <option key={e} value={e}>{e}</option>)}
              </select>
            </div>
            <div className="input-container">
              <label htmlFor="baciaHidrografica">Bacia hidrográfica</label>
              <select className="form-select" id="baciaHidrografica" name="baciaHidrografica" value={baciaHidrografica} onChange={e => handleFilterInput(e)}>
                <option value="todos">Todos</option>
                {baciaHidrograficaOptions.map((e) => <option key={e} value={e}>{e}</option>)}
              </select>
            </div>
          </div>
          <div className="input-group-row">
            <div className="input-container">
              <label htmlFor="finalidade">Finalidade</label>
              <select className="form-select" id="finalidade" name="finalidade" value={finalidade} onChange={e => handleFilterInput(e)}>
                <option value="todos">Todos</option>
                {finalidadeOptions.map((e) => <option key={e} value={e}>{e.replaceAll(`_`, ` `)}</option>)}
              </select>
            </div>
          </div>
          <div className="divider" />
          <div className="checkbox-group-column">
            <div className="checkbox-container">
              <input type="checkbox" id="novaOutorga" name="novaOutorga" checked={novaOutorga} onChange={e => handleFilterInput(e, true)} />
              <label className="form-check-label" htmlFor="novaOutorga">
                Nova outorga
              </label>
            </div>
            <div className="checkbox-container">
              <input type="checkbox" id="renovacaoOutorga" name="renovacaoOutorga" checked={renovacaoOutorga} onChange={e => handleFilterInput(e, true)} />
              <label className="form-check-label" htmlFor="renovacaoOutorga">
                Renovação de outorga
              </label>
            </div>
            <div className="checkbox-container">
              <input type="checkbox" id="outorgasVencidas" defaultChecked name="outorgasVencidas" checked={outorgasVencidas} onChange={e => handleFilterInput(e, true)} />
              <label className="form-check-label" htmlFor="outorgasVencidas">
                Outorgas vencidas
              </label>
            </div>
            <div className="checkbox-container">
              <input type="checkbox" id="outorgasNaoVencidas" defaultChecked name="outorgasNaoVencidas" checked={outorgasNaoVencidas} onChange={e => handleFilterInput(e, true)} />
              <label className="form-check-label" htmlFor="outorgasNaoVencidas">
                Outorgas Válidas
              </label>
            </div>
          </div>
          <div className="divider" />
          <div className="input-group-row input-date">
            <div className="input-container">
              <label>Data de emissão da outorga:</label>
              <div className="input-group-row">
                <input type="date" id="dataEmissaoInicial" name="dataEmissaoInicial" value={dataEmissaoInicial} onChange={e => handleFilterInput(e)} />
                <p>até</p>
                <input type="date" id="dataEmissaoFinal" name="dataEmissaoFinal" value={dataEmissaoFinal} onChange={e => handleFilterInput(e)} />
              </div>
              <label>Data de validade da outorga:</label>
              <div className="input-group-row">
                <input type="date" id="dataValidadeInicial" name="dataValidadeInicial" value={dataValidadeInicial} onChange={e => handleFilterInput(e)} />
                <p>até</p>
                <input type="date" id="dataValidadeFinal" name="dataValidadeFinal" value={dataValidadeFinal} onChange={e => handleFilterInput(e)} />
              </div>
            </div>
          </div>
          <div className="divider" />
          {
            isInitialized ?
              <div className="button-group">
                <button disabled={!isInitialized} onClick={handleSearch}>Buscar</button>
                <button onClick={handleClean}>Limpar</button>
              </div> :
              <>
                <p>Carregando...</p>
                <span className="loader"></span>
              </>
          }
        </div>
        <div className="box">
          <h2>Lista de outorgas</h2>
          <div className="divider" />
          {
            isLoading ?
              <>
                <p>Carregando...</p>
                <span className="loader"></span>
              </>
              :
              <>
                <div className="table-container">
                  <table className="styled-table">
                    <thead>
                      <tr>
                        <th>Nº da outorga</th>
                        <th>Nº do processo</th>
                        <th>Município fonte hídrica</th>
                        <th>Bacia hidrográfica</th>
                        <th>Finalidade</th>
                        <th>Tipo</th>
                        <th>Status</th>
                        <th>Emissão</th>
                        <th>Validade</th>
                        <th>PDF</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredList[page] && filteredList[page].map(e =>
                        <tr key={e.numeroProcesso}>
                          <td>{e.numeroOutorga}</td>
                          <td>{e.numeroProcesso}</td>
                          <td>{e.municipioFonteHidrica}</td>
                          <td>{e.baciaHidrografica}</td>
                          <td>{e.finalidade.replaceAll(`_`, ` `)}</td>
                          <td>{e.tipoSolicitacao === `RENOVACAO_OUTORGA` ? `Renovação` : `Nova`}</td>
                          <td>{isVencida(e.dataValidadeOutorga) ? `Vencida` : `Não vencida`}</td>
                          <td>{e.dataEmissaoOutorga.split(`-`)[2].split(`T`)[0]}/{e.dataEmissaoOutorga.split(`-`)[1]}/{e.dataEmissaoOutorga.split(`-`)[0]}</td>
                          <td>{e.dataValidadeOutorga.split(`-`)[2].split(`T`)[0]}/{e.dataValidadeOutorga.split(`-`)[1]}/{e.dataValidadeOutorga.split(`-`)[0]}</td>
                          <td><GetPDFButton numeroProcesso={e.numeroProcesso} /></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="paginator">
                  {
                    isInitialized
                      ?
                      <>
                        {
                          filteredList.length > 0 ?
                            <>
                              <p>{filteredListLength()} outorgas encontradas.</p>
                              <p>página {page + 1} de {filteredList.length}</p>
                            </> :
                            <p>Não há registros para essa busca</p>
                        }
                        <div className="paginator-buttons">
                          <button disabled={page === 0} onClick={() => handleCurrentPage(-1)}>
                            <i className="bi bi-arrow-left" ></i>
                            Anterior
                          </button>
                          <button disabled={page === filteredList.length - 1 || filteredList.length === 0} onClick={() => handleCurrentPage(+1)}>
                            Próxima
                            <i className="bi bi-arrow-right"></i>
                          </button>
                        </div>
                      </>
                      : <>
                        <p>página {page + 1} de ...</p>
                        <div className="loading-more">
                          <p>Carregando mais outorgas...</p>
                          <span className="loader"></span>
                        </div>
                      </>
                  }

                </div>
              </>
          }
        </div>
      </div>
      <div className="footer">
        <span>
          AESA - Outorgas Públicas <strong>powered by GTI</strong>
        </span>
      </div>
    </div>
  );
}

export default App;
